import React, { useState } from 'react';
import { Box, Typography, Grid, Input, Slider } from '@material-ui/core';
import { NumberInput } from '../../UI/Form';

const FilterRangeSlider = ({ name, label, min = 0, max, step = 1, onHandleChange }) => {
    const [sliderValue, setSliderValue] = useState([min, max]);

    const handleSliderChange = (event, newSliderValue) => {
        onHandleChange(name, sliderValue, 'range');
        setSliderValue(newSliderValue);
    };

    const handleInputChange = event => {
        if (event.target.name === 'minValue') {
            setSliderValue([+event.target?.value, sliderValue[1]]);
        } else if (event.target.name === 'maxValue') {
            setSliderValue([sliderValue[0], +event.target?.value]);
        }
        onHandleChange(name, sliderValue, 'range');
    };

    return (
        <Box>
            <Box mb={1}>
                <Typography variant="body2">{label}</Typography>
            </Box>
            <Box mb={1} textAlign="center">
                <Grid container spacing={0} alignItems="center" justify="space-between">
                    <Grid item xs={4}>
                        <Input
                            name="minValue"
                            value={sliderValue[0]}
                            inputProps={{ style: { textAlign: 'center' } }}
                            onChange={handleInputChange}
                            inputComponent={NumberInput}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <Typography color="textSecondary">—</Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Input
                            name="maxValue"
                            value={sliderValue[1]}
                            inputProps={{ style: { textAlign: 'center' } }}
                            onChange={handleInputChange}
                            inputComponent={NumberInput}
                        />
                    </Grid>
                </Grid>
            </Box>
            <Slider step={step} min={min} max={max} value={sliderValue} onChange={handleSliderChange} />
        </Box>
    );
};

export default FilterRangeSlider;
